import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { FC, ReactElement } from 'react';

import { theme } from '@/App/theme';
import { AboutUsLink } from '@/components/layout/AppFooter/AboutUsLink';
import { ConsultationsLink } from '@/components/layout/AppFooter/ConsultationsLink';
import { CookieSettingsLink } from '@/components/layout/AppFooter/CookieSettingsLink';
import { Copyright } from '@/components/layout/AppFooter/Copyright';
import { PrivacyPolicyLink } from '@/components/layout/AppFooter/PrivacyPolicyLink';
import { TermsOfUseLink } from '@/components/layout/AppFooter/TermsOfUseLink';

export const AppFooter: FC = (): ReactElement => {
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        marginTop: 'auto',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Divider sx={{ marginTop: 2 }} />
      <Container
        component="main"
        maxWidth={false}
        sx={{
          marginTop: 2,
          marginBottom: 1,
        }}
      >
        <Grid container spacing={1}>
          <Grid size={8}>
            <Stack {...(matches ? { direction: 'row' } : { direction: 'column' })} spacing={matches ? 2 : 1}>
              <TermsOfUseLink />
              <PrivacyPolicyLink />
              <CookieSettingsLink />
              <AboutUsLink />
              <ConsultationsLink />
            </Stack>
          </Grid>
          <Grid size={4}>
            <Copyright />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
